import React from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { Button, Alert, Card } from "react-bootstrap";
import axios from "axios";

import toastr from "toastr";
import "toastr/build/toastr.min.css";
const Step6 = ({ onComplete }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const formFinished = async () => {
    try {
      const response = await axios.post('/form-finished');
      
      if(response.data.status){
        toastr.success(response.data.message);
        // Trigger a custom event to notify Sidedrawer to refresh form status
        window.dispatchEvent(new Event('formStatusChanged'));
        // Navigate to home after a short delay to allow event to propagate
        setTimeout(() => {
          navigate("/home");
          // Refresh the page to ensure all components update with new form status
          window.location.reload();
        }, 300);
      } else {
        toastr.error(response.data.message);
      }
    } catch (error) {
      console.error('Error completing form:', error);
      toastr.error(t('steps.errorCompletingForm'));
    }
  }


  return (
    <div className="container w-75 mt-3">
      <Card className="p-4 text-center" style={{ border: 'none' }}>
        <Card.Body>
        <h5 className="text-[30px] font-semibold leading-[110%] text-[#25324B] tracking-wide mb-4">
        {t('steps.formCompleted')}
      </h5>
          <Alert variant="success">
            <strong>{t('answers.congratulations')}</strong> {t('steps.formCompletedSuccessfully')}
          </Alert>
          <Button
            onClick={formFinished}
            variant="success"
            className="mt-2 px-4 fs-5 bg-green-600"
          >
{t('steps.finish')}
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Step6;
